/**
 * This file is AUTO-GENERATED by tools/src/graphql-codegen/generate-register-operation-variables.ts
 * DO NOT EDIT MANUALLY.
 */
import { registerOperationVariables } from "@myvp/shared/src/functions/sanitize-graphql-input"
import sharedOperationVariables from "@myvp/shared/src/gql/operation-variables.json"
import eproViewerOperationVariables from "@myvp/epro-viewer/src/gql/operation-variables.json"
import todosOperationVariables from "@myvp/todos/src/gql/operation-variables.json"
import operationVariables from "src/gql/operation-variables.json"

registerOperationVariables(sharedOperationVariables)
registerOperationVariables(eproViewerOperationVariables)
registerOperationVariables(todosOperationVariables)
registerOperationVariables(operationVariables)
